import axios from "axios";

const apiUnitech = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL_UNITECH,
});

export default apiUnitech;
